<template>
    <div class="order">
        <div class="tabbar">
            <el-button
                    type="primary"
                    size="medium"
                    v-for="(item, index) in orderStatus"
                    :key="index"
                    :plain="item.value != query.status"
                    @click="changeTable(item)"
            >
                {{ item.label }}
            </el-button>
        </div>
        <div style="padding: 15px">
            <el-form :model="query" label-width="100px" :inline="true" class="demo-form-inline">
                <el-form-item label="工程名称" prop="title">
                    <el-input v-model="query.title" placeholder="请输入工程名称" clearable></el-input>
                </el-form-item>
                <!--<el-form-item label="状态" prop="status">-->
                    <!--&lt;!&ndash;<el-input v-model="query.status" placeholder="请输入工程名称"></el-input>&ndash;&gt;-->
                    <!--<el-select v-model="query.status" placeholder="请选择状态">-->
                        <!--<el-option-->
                                <!--v-for="item in orderStatus"-->
                                <!--:key="item.value"-->
                                <!--:label="item.label"-->
                                <!--:value="item.value">-->
                        <!--</el-option>-->
                    <!--</el-select>-->
                <!--</el-form-item>-->
                <el-form-item >
                    <el-button type="primary" @click="queryTable">搜索</el-button>
                    <!--<el-button @click="resetForm">重置</el-button>-->
                </el-form-item>
            </el-form>
        </div>
        <div class="table">
            <el-table :data="tableData" stripe>
                <el-table-column label="序号" align="center" width="100" type="index" :index="count"></el-table-column>
                <el-table-column prop="title" label="工程名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="need" label="用工需求" show-overflow-tooltip></el-table-column>
                <el-table-column prop="introduction" label="工程简介" show-overflow-tooltip></el-table-column>
                <el-table-column prop="address" label="作业地点" show-overflow-tooltip></el-table-column>
                <!--<el-table-column prop="days" label="工期（天）" width="100" show-overflow-tooltip></el-table-column>-->
                <!--<el-table-column prop="number" label="单价（元）" width="100" show-overflow-tooltip></el-table-column>-->
                <!--<el-table-column prop="price" label="总价（元）" width="100" show-overflow-tooltip></el-table-column>-->
                <el-table-column prop="status" label="订单状态" align="center" width="120">
                    <template scope="{row}">
                       {{formatStatus(row.status)}}
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template v-slot="scope">
                        <slot :row="scope.row" :column="scope.column">
                            <div class="">
                                <div style="cursor: pointer;color: blue;" @click="hanldeCheck(scope.row)">查 看</div>
                            </div>
                        </slot>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div style="display: flex; justify-content: flex-end;margin-top: 20px;padding-bottom: 20px;"  v-if="total" >
            <el-pagination
                    background
                    layout="prev, pager, next,total"
                    :total="total"
                    :current-page="query.pageNum"
                    :page-size="query.pageSize"
                    @current-change="handleCurrentChange"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import api from "@/http/electrician/api.js";
    import { mapGetters } from 'vuex';

    export default {
        name: "order",
        data() {
            return {
                statusIndex: '',
                tableData: [],
                query: {
                    pageSize: 10,
                    pageNum: 1,
                    title: '',
                    status: ''
                },
                total: 0,
            };
        },
        methods: {
            count(index) {
                return (this.query.pageNum - 1) * this.query.pageSize + index + 1;
            },
            hanldeCheck(row) {
                this.$router.push({
                    path: "/electricianUser/eleDetail",
                    query: {
                        id: row.needId,
                    },
                });
            },
            getOrderList() {
                api.shareOrderList(this.query).then(res => {
                    if(res.code === 200){
                        this.tableData = res.rows;
                        this.total = res.total;
                    }
                });
            },
            changeTable(item) {
                this.query.pageNum = 1;
                this.query.status = item.value;
                this.getOrderList();
            },
            handleCurrentChange(val) {
                this.query.pageNum = val;
                this.getOrderList();
            },
            queryTable(){
                this.query.pageNum = 1;
                this.getOrderList();
            },
            resetForm(){
                this.query.title = '';
                this.query.status = '';
                this.queryTable();
            },
            //
            formatStatus(obj){
                const data = this.orderStatus.find(item => item.value === obj);
                if(data){
                    return data.label;
                }
                return "";
            }
        },
        created: function () {
            this.getOrderList();
        },
        computed:{
            ...mapGetters(['needStatus', 'orderStatus'])
        }
    };
</script>

<style lang="less" scoped="scoped">
    .order {
        width: 100%;
        min-height: 700px;
        background: @vue-bg-color;

        .tabbar {
            width: 100%;
            height: 60px;
            display: flex;
            align-items: flex-end;
            padding: 0px @vue-spacing-row-base;
            box-sizing: border-box;
        }

        .table {
            width: 100%;
            padding: @vue-spacing-col-base @vue-spacing-row-base;
            box-sizing: border-box;

            .table-order-status {
                span {
                    color: @vue-text-color-red;
                }
            }
        }

        .page-pager {
            width: 100%;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding: 0px @vue-spacing-row-lg;
            box-sizing: border-box;
        }
    }
</style>
